/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ updatedBy: NonNullable<unknown>, status: NonNullable<unknown> }} Dashboard_Log_EntryInputs */

const en_dashboard_log_entry = /** @type {(inputs: Dashboard_Log_EntryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updater: ${i?.updatedBy} · Column: ${i?.status}`)
};

const pt_br2_dashboard_log_entry = /** @type {(inputs: Dashboard_Log_EntryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Responsável: ${i?.updatedBy} · Status: ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Updater: {updatedBy} · Column: {status}" |
*
* @param {Dashboard_Log_EntryInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_log_entry = /** @type {((inputs: Dashboard_Log_EntryInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Log_EntryInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_log_entry(inputs)
	return pt_br2_dashboard_log_entry(inputs)
});